import type { PublicPageDefinition } from './types';

export const PUBLIC_PAGE_REGISTRY: PublicPageDefinition[] = [
  {
    id: 'space-write',
    kind: 'app-shell',
    selector: '[data-space-write-root], [data-static-root][data-content="write"]',
    configId: 'space-write-config',
    load: () => import('../pages/spaceWritePage'),
  },
  {
    id: 'space-read',
    kind: 'app-shell',
    selector: '[data-page="space-reading"], [data-static-root][data-content="read"]',
    configId: 'space-reading-config',
    load: () => import('../pages/spaceReadPage'),
  },
  {
    id: 'space-text',
    kind: 'dynamic-text',
    selector: '[data-page="space-text"], [data-space-text-root]',
    configId: 'space-text-config',
    allowHashManage: true,
    load: () => import('../pages/spaceTextRuntimePage'),
  },
  {
    id: 'account-claim',
    kind: 'app-shell',
    selector: '[data-page="account-claim"], [data-account-claim-root]',
    configId: 'space-account-claim-config',
    load: () => import('../pages/spaceAccountClaimPage'),
  },

  {
    id: 'account-home',
    kind: 'app-shell',
    selector: '[data-page="account-home"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-login',
    kind: 'app-shell',
    selector: '[data-page="account-login"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-register',
    kind: 'app-shell',
    selector: '[data-page="account-register"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-recover',
    kind: 'app-shell',
    selector: '[data-page="account-recover"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-texts',
    kind: 'app-shell',
    selector: '[data-page="account-texts"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-saved',
    kind: 'app-shell',
    selector: '[data-page="account-saved"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-recent',
    kind: 'app-shell',
    selector: '[data-page="account-recent"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-reading',
    kind: 'app-shell',
    selector: '[data-page="account-reading"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-translations',
    kind: 'app-shell',
    selector: '[data-page="account-translations"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-support',
    kind: 'app-shell',
    selector: '[data-page="account-support"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-security',
    kind: 'app-shell',
    selector: '[data-page="account-security"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'account-settings',
    kind: 'app-shell',
    selector: '[data-page="account-settings"], [data-account-root]',
    configId: 'account-runtime-config',
    load: () => import('../pages/accountPage'),
  },
  {
    id: 'presence',
    kind: 'app-shell',
    selector: '[data-page="presence"], [data-presence-root]',
    configId: 'presence-config',
    load: () => import('../pages/presencePage'),
  },
  {
    id: 'feedback',
    kind: 'app-shell',
    selector: '[data-page="feedback"], [data-feedback-root]',
    configId: 'feedback-config',
    load: () => import('../pages/feedbackPage'),
  },
];

export function findPageDefinitionByRoute(
  pathname = window.location.pathname,
  hash = window.location.hash,
): PublicPageDefinition | null {
  // Imported lazily in app.ts for route matching during boot. This helper exists for tests and diagnostics.
  void pathname;
  void hash;
  return null;
}
